import * as XLSX from 'xlsx';

type ExportResult = { ok: true } | { ok: false; error: unknown };

export const formatPhone = (phone: any, phoneNumber?: string): string => {
  if (phone) {
    if (typeof phone === 'string') return phone;
    if (typeof phone === 'object' && phone.number) {
      return phone.countryCode ? `${phone.countryCode} ${phone.number}` : phone.number;
    }
  }
  if (phoneNumber) return phoneNumber;
  return '';
};

export const formatAddress = (address: any): string => {
  if (!address) return '';
  if (typeof address === 'string') return address;
  if (typeof address === 'object') {
    const parts = [
      address.street,
      address.city,
      address.state,
      address.zip,
      address.country,
    ].filter(Boolean);
    return parts.length > 0 ? parts.join(', ') : '';
  }
  return '';
};

export const downloadCustomersExcel = (customers: any[], restaurantName: string): ExportResult => {
  try {
    const exportData = customers.map((customer) => ({
      'Name': customer.name || '',
      'Email': customer.email || '',
      'Phone': formatPhone(customer.phone, customer.phoneNumber),
      'Address': formatAddress(customer.address),
      'Join Date': customer.createdAt ? new Date(customer.createdAt).toLocaleDateString() : '',
      'Customer ID': customer._id || '',
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    worksheet['!cols'] = [
      { wch: 25 }, // Name
      { wch: 35 }, // Email
      { wch: 20 }, // Phone
      { wch: 50 }, // Address
      { wch: 15 }, // Join Date
      { wch: 30 }, // Customer ID
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Customers');

    const dateStr = new Date().toISOString().split('T')[0];
    const filename = `customers_${restaurantName.replace(/[^a-z0-9]/gi, '_')}_${dateStr}.xlsx`;

    XLSX.writeFile(workbook, filename);
    return { ok: true };
  } catch (error) {
    return { ok: false, error };
  }
};
